import { createAction } from "redux-actions";

const namespace = "app/menu";

const FETCH_MENU = `${namespace}/FETCH_MENU`;
const FETCH_MENU_ERROR = `${namespace}/FETCH_MENU_ERROR`;
const FETCH_MENU_SUCCESS = `${namespace}/FETCH_MENU_SUCCESS`;
const FETCH_PROFILE_MENU = `${namespace}/FETCH_PROFILE_MENU`;
const FETCH_PROFILE_MENU_ERROR = `${namespace}/FETCH_PROFILE_MENU_ERROR`;
const FETCH_PROFILE_MENU_SUCCESS = `${namespace}/FETCH_PROFILE_MENU_SUCCESS`;
const CLEAR_PROFILE_MENU = `${namespace}/CLEAR_PROFILE_MENU`;

export const constants = {
  FETCH_MENU,
  FETCH_MENU_ERROR,
  FETCH_MENU_SUCCESS,
  FETCH_PROFILE_MENU,
  FETCH_PROFILE_MENU_ERROR,
  FETCH_PROFILE_MENU_SUCCESS,
  CLEAR_PROFILE_MENU
};

const fetchMenu = createAction(FETCH_MENU, () => ({}));
const fetchMenuError = createAction(FETCH_MENU_ERROR, () => ({}));
const fetchMenuSuccess = createAction(FETCH_MENU_SUCCESS, (data: Object) => ({
  data
}));
const fetchProfileMenu = createAction(FETCH_PROFILE_MENU, () => ({}));
const fetchProfileMenuError = createAction(FETCH_PROFILE_MENU_ERROR, () => ({}));
const fetchProfileMenuSuccess = createAction(
  FETCH_PROFILE_MENU_SUCCESS,
  (data: Object) => ({
    data
  })
);
const clearProfileMenu = createAction(CLEAR_PROFILE_MENU, () => ({}));

export const actions = {
  fetchMenu,
  fetchMenuError,
  fetchMenuSuccess,
  fetchProfileMenu,
  fetchProfileMenuError,
  fetchProfileMenuSuccess,
  clearProfileMenu
};

const initialState = {
  loading: false,
  data: [],
  profileLoading: false,
  profileData: [],
  profileFetched: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_MENU:
      return {
        ...state,
        loading: true
      };

    case FETCH_MENU_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data
      };

    case FETCH_MENU_ERROR:
      return {
        ...state,
        loading: false,
        data: []
      };

    case FETCH_PROFILE_MENU:
      if (state.profileFetched || state.profileLoading) {
        return state;
      }

      return {
        ...state,
        profileLoading: true
      };

    case FETCH_PROFILE_MENU_SUCCESS:
      return {
        ...state,
        profileLoading: false,
        profileFetched: true,
        profileData: action.payload.data
      };

    case FETCH_PROFILE_MENU_ERROR:
      return {
        ...state,
        profileLoading: false,
        profileFetched: false,
        profileData: []
      };

    case CLEAR_PROFILE_MENU:
      return {
        ...state,
        profileLoading: false,
        profileFetched: false,
        profileData: []
      };

    default:
      return state;
  }
}
